import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CplRequestItem } from '../../../../model/cpl-request-item.model';
import { CplUserRequest } from '../../../../model/cpl-user-request.model';
import { VerificationHistory } from '../../../../model/cpl-verification-history.model';
import { RequestHelpersService } from '../../../../services/request-helpers/request-helpers.service';
import { RequestVerifyService } from '../../../../services/request-verify.service';
import { RequestVerificationStatus } from '../../../enums/verification-status.enum';

@Component({
    selector:    'user-request-summary',
    templateUrl: './user-request-summary.component.html',
    styleUrls: ['./user-request-summary.component.scss']
})
export class UserRequestDetailsSummary implements OnInit { 
    @Input() userRequest: CplUserRequest;
    @Input() request: CplRequestItem;

    @Output() onSubmissionComplete = new EventEmitter();

    verificationHistory  = Array<VerificationHistory>();
    RequestVerificationStatus = RequestVerificationStatus;

    constructor(
        public requestHelpersService: RequestHelpersService,
        private requestService: RequestVerifyService
    ) {}

    ngOnInit() {    
        this.requestService
            .getVerifyHistoryByUserRequestId(this.userRequest.UserRequestID)
            .subscribe((result: Array<VerificationHistory>) => {
                this.verificationHistory = result;
            });
    }

    onMessagesClicked() {
        this.onSubmissionComplete.emit();
    }
}